import React from 'react'
import useStyles from './styles'

const InstagramStoryWrapper = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.adStoriesCard}>{children}</div>
}

export default InstagramStoryWrapper
